// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // adminUrl: 'https://www.amalooloo.group',
  // apiUrl: 'https://www.amalooloo.group/api',
  // apiBaseUrl: 'https://amalooloo.group/images',
  // imageUrl:'https://amalooloo.group/images',

  maitenanceworkerurl: "https://dev.amalooloo.group",
  adminUrl: "https://dev.amalooloo.group",
  apiUrl: "https://dev.amalooloo.group/api",
  apiBaseUrl: "https://dev.amalooloo.group/images",
  imageUrl: "https://dev.amalooloo.group/images",
};
